import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {StandingsClickEvent} from "../models/events/standings-click-event";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";

export class StandingsClickEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.standingsClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = StandingsClickEvent;
  }
}
